"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactTextMask = _interopRequireDefault(require("react-text-mask"));

var _classnames = _interopRequireDefault(require("classnames"));

var _prefix = _interopRequireDefault(require("../../prefix"));

var MaskedTextInput = function MaskedTextInput(_ref) {
  var autoComplete = _ref.autoComplete,
      autoFocus = _ref.autoFocus,
      disabled = _ref.disabled,
      htmlId = _ref.htmlId,
      _ref$masking = _ref.masking,
      guide = _ref$masking.guide,
      mask = _ref$masking.mask,
      pipe = _ref$masking.pipe,
      name = _ref.name,
      placeholder = _ref.placeholder,
      readOnly = _ref.readOnly,
      required = _ref.required,
      type = _ref.type,
      onBlur = _ref.onBlur,
      onTextInputChange = _ref.onTextInputChange,
      onFocus = _ref.onFocus,
      onKeyDown = _ref.onKeyDown,
      value = _ref.value;
  return /*#__PURE__*/_react["default"].createElement(_reactTextMask["default"], {
    className: (0, _classnames["default"])(["".concat(_prefix["default"], "form-control"), "".concat(htmlId, "-maskedInput")]),
    id: htmlId + "-maskedInput",
    onBlur: onBlur,
    onChange: onTextInputChange,
    onFocus: onFocus,
    type: type || "text",
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    disabled: disabled,
    guide: guide,
    mask: mask,
    name: name,
    onKeyDown: onKeyDown,
    pipe: pipe,
    placeholder: placeholder,
    readOnly: readOnly,
    required: required,
    value: value
  });
};

var _default = MaskedTextInput;
exports["default"] = _default;